/**
 * Product card swiper: modo "colors" (agrupados) o "media" (galería del mismo producto).
 */
(function () {
  if (!window.theme || !theme.settings) return;

  var hasColorCarousel = !!theme.settings.enableCardImageCarousel;
  var hasMediaCarousel =
    theme.settings.cardImageDisplayMode === 'media_carousel';

  if (!hasColorCarousel && !hasMediaCarousel) return;

  var DEFAULT_MAX_COLOR_SLIDES = 4;

  function getCarouselMode(swiperElement) {
    return swiperElement.getAttribute('data-carousel-mode') || 'colors';
  }

  function isColorCarousel(swiperElement) {
    return getCarouselMode(swiperElement) === 'colors';
  }

  function eventTargetElement(evt) {
    if (!evt || !evt.target) return null;
    var target = evt.target;
    return target.nodeType === 1 ? target : target.parentElement || null;
  }

  function closestFromEvent(evt, selector) {
    var el = eventTargetElement(evt);
    return el && typeof el.closest === 'function' ? el.closest(selector) : null;
  }

  function isListingPage() {
    return (
      document.body &&
      (document.body.classList.contains('template-collection') ||
        document.body.classList.contains('template-search'))
    );
  }

  function getNavRoot(swiperElement) {
    return (
      swiperElement.closest('.grid-product__image-mask--carousel') || swiperElement
    );
  }

  function getMaxSlidesForSwiper(swiperElement) {
    var fromAttr = parseInt(swiperElement.getAttribute('data-max-slides'), 10);
    if (!isNaN(fromAttr) && fromAttr > 0) return fromAttr;
    return isColorCarousel(swiperElement) ? DEFAULT_MAX_COLOR_SLIDES : 20;
  }

  function trimSlidesToMax(swiperElement) {
    var maxSlides = getMaxSlidesForSwiper(swiperElement);
    var slides = Array.prototype.slice.call(
      swiperElement.querySelectorAll('.swiper-slide')
    );
    if (slides.length > maxSlides) {
      slides.slice(maxSlides).forEach(function (slide) {
        slide.remove();
      });
    }
    return swiperElement.querySelectorAll('.swiper-slide').length;
  }

  function markDeferredNavState(swiperElement) {
    var navRoot = getNavRoot(swiperElement);
    var prev = navRoot.querySelector('.swiper-button-prev');
    var next = navRoot.querySelector('.swiper-button-next');
    var slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

    if (prev) {
      prev.classList.add('swiper-button-disabled', 'ark-card-swiper-nav--dimmed');
    }
    if (next) {
      var nextDisabled = slideCount <= 1;
      next.classList.toggle('swiper-button-disabled', nextDisabled);
      next.classList.toggle('ark-card-swiper-nav--dimmed', nextDisabled);
    }
  }

  function applyNavOpacityState(swiperInstance) {
    if (!swiperInstance) return;
    var navRoot = getNavRoot(swiperInstance.el);
    var prev = navRoot.querySelector('.swiper-button-prev');
    var next = navRoot.querySelector('.swiper-button-next');
    var atStart = swiperInstance.isBeginning;
    var atEnd = swiperInstance.isEnd;

    if (prev) {
      prev.classList.toggle('swiper-button-disabled', atStart);
      prev.classList.toggle('ark-card-swiper-nav--dimmed', atStart);
    }
    if (next) {
      next.classList.toggle('swiper-button-disabled', atEnd);
      next.classList.toggle('ark-card-swiper-nav--dimmed', atEnd);
    }
  }

  function dispatchSlideChange(swiperEl, handle) {
    var card = swiperEl.closest('.grid-product');
    if (!card || !handle) return;
    document.dispatchEvent(
      new CustomEvent('ark:card-swiper:change', {
        bubbles: true,
        detail: { card: card, handle: handle, swiperEl: swiperEl },
      })
    );
  }

  function syncSwatchFromHandle(card, handle) {
    var wrapper = card.querySelector('.color_swatches_wrapper.col-grid');
    if (!wrapper) return;

    var swatches = wrapper.querySelectorAll(
      '.ark-color-switcher[data-handle]:not(.color-swatch-additional)'
    );
    var match = null;
    swatches.forEach(function (el) {
      if (el.getAttribute('data-handle') === handle) match = el;
    });
    if (!match) return;

    swatches.forEach(function (el) {
      var isActive = el === match;
      el.classList.toggle('selected', isActive);
      if (isActive) {
        el.setAttribute('aria-current', 'true');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  }

  function syncMainProductLink(card, slide) {
    if (!card || !slide) return;
    var mainLink = card.querySelector('.grid-product__link');
    if (!mainLink) return;

    var slideLink = slide.querySelector('.ark-card-swiper__link');
    var url =
      (slideLink && slideLink.getAttribute('href')) ||
      slide.getAttribute('data-product-url');
    if (url) mainLink.href = url;
  }

  function syncFromActiveSlide(swiperElement, swiperInstance) {
    if (!isColorCarousel(swiperElement)) return;

    var card = swiperElement.closest('.grid-product');
    if (!card || !swiperInstance || !swiperInstance.slides) return;

    var slide = swiperInstance.slides[swiperInstance.activeIndex];
    if (!slide) return;

    var handle = slide.getAttribute('data-product-handle');
    if (handle) syncSwatchFromHandle(card, handle);
    syncMainProductLink(card, slide);
  }

  function updateNavigationState(swiperInstance) {
    if (
      swiperInstance &&
      swiperInstance.navigation &&
      typeof swiperInstance.navigation.update === 'function'
    ) {
      swiperInstance.navigation.update();
    }
    applyNavOpacityState(swiperInstance);
  }

  function findDeferredSwiperFromEvent(evt) {
    var swiperEl = closestFromEvent(
      evt,
      '.ark-product-card-swiper[data-swiper-defer-listing]'
    );
    if (swiperEl) return swiperEl;

    var nav = closestFromEvent(evt, '.grid-product__image-mask--carousel .ark-card-swiper-nav');
    if (!nav) return null;

    var mask = nav.closest('.grid-product__image-mask--carousel');
    if (!mask) return null;

    return mask.querySelector('.ark-product-card-swiper');
  }

  window.slideArkProductCardSwiperToHandle = function (swiperEl, handle, options) {
    if (!swiperEl || !handle || !isColorCarousel(swiperEl)) return false;
    var opts = options || {};
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    var targetIndex = -1;

    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-product-handle') === handle) {
        targetIndex = i;
        break;
      }
    }
    if (targetIndex < 0) return false;
    if (typeof Swiper === 'undefined') return false;

    var instance = swiperEl.swiper;
    if (!instance || instance.destroyed) {
      if (typeof window.__initSingleArkProductCardSwiper !== 'function') return false;
      if (!window.__initSingleArkProductCardSwiper(swiperEl)) return false;
      instance = swiperEl.swiper;
    }
    if (!instance || instance.destroyed) return false;

    swiperEl.removeAttribute('data-swiper-defer-listing');

    var slideFinished = false;

    function finishSlide() {
      if (slideFinished) return;
      slideFinished = true;
      syncFromActiveSlide(swiperEl, instance);
      updateNavigationState(instance);
      if (opts.suppressMetaDispatch) {
        delete swiperEl.dataset.arkSuppressSlideDispatch;
      }
      if (typeof opts.onComplete === 'function') {
        opts.onComplete(instance);
      }
    }

    if (opts.suppressMetaDispatch) {
      swiperEl.dataset.arkSuppressSlideDispatch = handle;
    }

    if (instance.activeIndex !== targetIndex) {
      var onTransitionEnd = function () {
        instance.off('slideChangeTransitionEnd', onTransitionEnd);
        finishSlide();
      };
      instance.on('slideChangeTransitionEnd', onTransitionEnd);
      instance.slideTo(targetIndex);
      window.setTimeout(function () {
        instance.off('slideChangeTransitionEnd', onTransitionEnd);
        finishSlide();
      }, 400);
    } else {
      finishSlide();
    }
    return true;
  };

  window.__initSingleArkProductCardSwiper = function (swiperElement) {
    if (typeof Swiper === 'undefined') return false;
    if (!swiperElement || swiperElement.dataset.swiperInitialized === 'true') {
      return false;
    }

    var remaining = trimSlidesToMax(swiperElement);
    if (remaining < 1) return false;

    var initialSlide = 0;
    var initialAttr = swiperElement.getAttribute('data-initial-slide');
    if (initialAttr !== null && initialAttr !== '') {
      var parsed = parseInt(initialAttr, 10);
      if (!isNaN(parsed)) initialSlide = parsed;
    }
    initialSlide = Math.max(0, Math.min(initialSlide, remaining - 1));

    var navRoot = getNavRoot(swiperElement);
    var nextEl = navRoot.querySelector('.swiper-button-next');
    var prevEl = navRoot.querySelector('.swiper-button-prev');
    var allowSlideChangeEvent = false;

    var swiperInstance;
    try {
      swiperInstance = new Swiper(swiperElement, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        rewind: false,
        initialSlide: initialSlide,
        roundLengths: true,
        watchOverflow: true,
        resistance: true,
        resistanceRatio: 0,
        touchReleaseOnEdges: true,
        preventInteractionOnTransition: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
          disabledClass: 'swiper-button-disabled ark-card-swiper-nav--dimmed',
        },
        speed: 300,
        preventClicks: false,
        preventClicksPropagation: false,
        on: {
          init: function () {
            syncFromActiveSlide(swiperElement, this);
            updateNavigationState(this);
            window.requestAnimationFrame(function () {
              allowSlideChangeEvent = true;
            });
          },
          slideChange: function () {
            if (isColorCarousel(swiperElement)) {
              syncFromActiveSlide(swiperElement, this);
              var slide = this.slides[this.activeIndex];
              var handle = slide && slide.getAttribute('data-product-handle');
              var suppressedHandle =
                swiperElement.dataset.arkSuppressSlideDispatch;
              if (handle && suppressedHandle === handle) {
                delete swiperElement.dataset.arkSuppressSlideDispatch;
              } else if (allowSlideChangeEvent && handle) {
                dispatchSlideChange(swiperElement, handle);
              }
            }
            updateNavigationState(this);
          },
        },
      });
    } catch (e) {
      console.error(e);
      return false;
    }

    swiperElement.dataset.swiperInitialized = 'true';
    swiperElement.removeAttribute('data-swiper-defer-listing');
    installMediaCarouselHover(swiperElement, swiperInstance);
    return !!swiperInstance;
  };

  function bindMediaCarouselHover(swiperElement) {
    if (!theme.settings.cardCarouselHoverImage) return;
    if (getCarouselMode(swiperElement) !== 'media') return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (swiperElement.querySelectorAll('.swiper-slide').length < 2) return;
    if (swiperElement.dataset.arkMediaHoverBound === '1') return;

    swiperElement.dataset.arkMediaHoverBound = '1';

    var card = swiperElement.closest('.grid-product');
    var hoverTarget =
      swiperElement.closest('.grid-product__image-mask--carousel') || card;
    if (!hoverTarget) return;

    swiperElement.querySelectorAll('.grid-product__secondary-image').forEach(function (el) {
      el.remove();
    });

    var HOVER_INDEX = 1;
    var hoverActive = false;

    function isHoverNavDisabled() {
      return (
        swiperElement.dataset.arkHoverNavDisabled === '1' ||
        swiperElement.dataset.arkPeekRunning === '1'
      );
    }

    function ensureSwiperReady() {
      if (swiperElement.swiper && !swiperElement.swiper.destroyed) {
        return swiperElement.swiper;
      }
      if (typeof window.__initSingleArkProductCardSwiper !== 'function') return null;
      swiperElement.removeAttribute('data-swiper-defer-listing');
      if (!window.__initSingleArkProductCardSwiper(swiperElement)) return null;
      return swiperElement.swiper && !swiperElement.swiper.destroyed
        ? swiperElement.swiper
        : null;
    }

    function disableHoverNav() {
      swiperElement.dataset.arkHoverNavDisabled = '1';
      hoverActive = false;
    }

    function goToHoverSlide() {
      if (isHoverNavDisabled()) return;
      var instance = ensureSwiperReady();
      if (!instance) return;
      if (instance.activeIndex !== 0) return;
      hoverActive = true;
      instance.slideTo(HOVER_INDEX, 0);
    }

    function goToFirstSlide() {
      if (isHoverNavDisabled()) return;
      if (!swiperElement.swiper || swiperElement.swiper.destroyed) return;
      if (!hoverActive) return;
      hoverActive = false;
      if (swiperElement.swiper.activeIndex === HOVER_INDEX) {
        swiperElement.swiper.slideTo(0, 0);
      }
    }

    hoverTarget.addEventListener('mouseenter', goToHoverSlide);
    hoverTarget.addEventListener('mouseleave', goToFirstSlide);

    swiperElement._arkMediaHoverCleanup = function () {
      hoverTarget.removeEventListener('mouseenter', goToHoverSlide);
      hoverTarget.removeEventListener('mouseleave', goToFirstSlide);
      delete swiperElement.dataset.arkMediaHoverBound;
      delete swiperElement._arkMediaHoverCleanup;
    };
  }

  function attachMediaCarouselHoverSwiper(swiperElement, swiperInstance) {
    if (!theme.settings.cardCarouselHoverImage) return;
    if (getCarouselMode(swiperElement) !== 'media') return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (!swiperInstance || swiperInstance.destroyed) return;
    if (swiperInstance.slides.length < 2) return;
    if (swiperElement.dataset.arkMediaHoverSwiperBound === '1') return;

    swiperElement.dataset.arkMediaHoverSwiperBound = '1';

    function disableHoverNav() {
      swiperElement.dataset.arkHoverNavDisabled = '1';
    }

    swiperInstance.on('touchStart', disableHoverNav);
    swiperInstance.on('sliderFirstMove', disableHoverNav);

    var navRoot = getNavRoot(swiperElement);
    var nextBtn = navRoot.querySelector('.swiper-button-next');
    var prevBtn = navRoot.querySelector('.swiper-button-prev');
    if (nextBtn) nextBtn.addEventListener('click', disableHoverNav);
    if (prevBtn) prevBtn.addEventListener('click', disableHoverNav);

    var prevCleanup = swiperElement._arkMediaHoverCleanup;
    swiperElement._arkMediaHoverCleanup = function () {
      if (nextBtn) nextBtn.removeEventListener('click', disableHoverNav);
      if (prevBtn) prevBtn.removeEventListener('click', disableHoverNav);
      delete swiperElement.dataset.arkMediaHoverSwiperBound;
      if (typeof prevCleanup === 'function') prevCleanup();
    };
  }

  function installMediaCarouselHover(swiperElement, swiperInstance) {
    bindMediaCarouselHover(swiperElement);
    attachMediaCarouselHoverSwiper(swiperElement, swiperInstance);
  }

  window.__cleanupArkMediaCarouselHover = function (swiperElement) {
    if (swiperElement && typeof swiperElement._arkMediaHoverCleanup === 'function') {
      swiperElement._arkMediaHoverCleanup();
    }
    if (swiperElement) {
      delete swiperElement.dataset.arkHoverNavDisabled;
      delete swiperElement.dataset.arkMediaHoverBound;
      delete swiperElement.dataset.arkMediaHoverSwiperBound;
    }
  };

  function bootSwiper(swiperEl) {
    if (!swiperEl || swiperEl.dataset.swiperInitialized === 'true') return;
    window.__initSingleArkProductCardSwiper(swiperEl);
  }

  function bootSwiperFromEvent(evt) {
    var swiperEl = findDeferredSwiperFromEvent(evt);
    if (swiperEl) bootSwiper(swiperEl);
  }

  function initProductCardSwipers(root, options) {
    var opts = options || {};
    var eager = opts.eager === true;
    var scope = root && root.querySelectorAll ? root : document;
    var swipers = scope.querySelectorAll('.ark-product-card-swiper');
    var deferListings = !eager && isListingPage();

    if (deferListings) {
      swipers.forEach(function (el) {
        if (el.dataset.swiperInitialized === 'true') return;
        el.setAttribute('data-swiper-defer-listing', 'true');
        markDeferredNavState(el);
        bindMediaCarouselHover(el);
      });
      return;
    }

    function run() {
      swipers.forEach(function (el) {
        bindMediaCarouselHover(el);
        window.__initSingleArkProductCardSwiper(el);
      });
    }

    if (typeof Swiper === 'undefined') {
      var attempts = 0;
      var id = window.setInterval(function () {
        attempts += 1;
        if (typeof Swiper !== 'undefined') {
          window.clearInterval(id);
          run();
        } else if (attempts > 500) {
          window.clearInterval(id);
        }
      }, 40);
      return;
    }

    run();
  }

  if (!window.__arkListingSwiperDeferInstalled) {
    window.__arkListingSwiperDeferInstalled = true;

    document.addEventListener('pointerdown', bootSwiperFromEvent, true);
    document.addEventListener('touchstart', bootSwiperFromEvent, {
      capture: true,
      passive: true,
    });
  }

  function onReady() {
    initProductCardSwipers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initProductCardSwipers(evt.target, { eager: true });
  });
})();
